/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Utils
import { extractLanguageCode } from 'libs/utils/language';
import { isEmpty } from 'lodash';

// Components
import UploadManager from 'shared/ui/components/uploader/UploadManager.vue';

const __vue_script__ = {
    name: 'ClosedCaptionsFormElement',

    components: {
        UploadManager
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        contentDoc: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            workerScope: null,
            worker: null,
            sentFiles: []
        };
    },

    computed: {
        uploadedSubtitleFiles() {
            const subtitleFiles = this.contentDoc.subtitle_files || [];
            const allLang = this.$utils.locales.getAllLanguages();
            return subtitleFiles
                .filter(file => file.original_file_name)
                .map(file => {
                    const lang = extractLanguageCode(file.name);
                    const language = allLang[lang]?.englishName;
                    if (!language) {
                        return null;
                    }
                    return {
                        ...file,
                        lang,
                        language
                    };
                }).filter(Boolean);
        },

        hasSubtitleFiles() {
            return this.uploadedSubtitleFiles.length > 0;
        },

        isProcessingSubtitles() {
            return this.contentDoc.processing_subtitles;
        },

        hasEmbededCaptions() {
            if (isEmpty(this.contentDoc.live_captions_labels)) {
                return false;
            }

            for (const key in this.contentDoc.live_captions_labels) {
                if (this.contentDoc.live_captions_labels[key]?.length) {
                    return true;
                }
            }

            return false;
        }
    },

    watch: {
        contentDoc: {
            deep: true,
            handler: function() {
                const attachmentErrors = this.contentDoc.attachment_errors || {};
                const names = new Set(Object.keys(attachmentErrors));

                this.sentFiles.forEach(fileId => {
                    if (!names.has(fileId)) return;

                    const errorDetails = attachmentErrors[fileId];

                    let text = this.$i18n.t('contents.closed_captions.upload_error').toString();

                    if (errorDetails.original_error_message) {
                        text = `${text} - ${errorDetails.original_error_message}`;
                    }

                    this.$notify({
                        group: 'flashes',
                        text,
                        type: 'error',
                        duration: 15000
                    });

                    this.sentFiles = this.sentFiles.filter(id => id !== fileId);
                });
            },
        }
    },

    methods: {
        openCaptionsPicker() {
            const event = new CustomEvent('start-uploader', {
                detail: {
                    customModal: {
                        modalComponent: 'VttPicker',
                        fpType: this.contentDoc.fp_type,
                        assetId: this.contentDoc.id || this.contentDoc._id,
                        uploadedSubtitleFiles: this.uploadedSubtitleFiles,
                        onSubmitHook: (sentFiles) => this.sentFiles = sentFiles
                    }
                }
            });
            window.dispatchEvent(event);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "closed-captions" },
    [
      _vm._t("default"),
      _vm.hasEmbededCaptions
        ? _c("div", { staticClass: "captions-already-in-video control-hint" }, [
            _vm._v(
              _vm._s(
                _vm.$t("contents.closed_captions.captions_already_in_video")
              )
            ),
          ])
        : _vm.isProcessingSubtitles
        ? _c("div", { staticClass: "badge" }, [
            _vm._v(_vm._s(_vm.$t("contents.detail.processing"))),
          ])
        : _c(
            "div",
            { staticClass: "caption-languages" },
            _vm._l(_vm.uploadedSubtitleFiles, function (file) {
              return _c(
                "div",
                { key: file.language, staticClass: "caption-language" },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(file.language)),
                  ]),
                ]
              )
            }),
            0
          ),
      !_vm.hasEmbededCaptions && !_vm.isProcessingSubtitles
        ? _c("a", { on: { click: _vm.openCaptionsPicker } }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  _vm.hasSubtitleFiles
                    ? "contents.closed_captions.edit"
                    : "contents.closed_captions.add"
                )
              )
            ),
          ])
        : _vm._e(),
      _vm.workerScope
        ? _c("upload-manager", {
            attrs: {
              worker: _vm.worker,
              "worker-scope": _vm.workerScope,
              event: _vm.event,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/ClosedCaptionsFormElement.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__